import { TransactionTypeEnum } from './transaction-type.enum';

export class TransactionTypeModel {
    public static TransactionTypeList: Array<any> = [
        { name: 'All', value: 0 },
        { name: 'Preauth', value: TransactionTypeEnum.Preauth },
        { name: 'Capture', value: TransactionTypeEnum.Capture },
        { name: 'Customer Tip', value: TransactionTypeEnum.CustomerTip },
        { name: 'Rider Transfer From Xpress Wallet', value: TransactionTypeEnum.RiderTransferFromXpressWallet },
        { name: 'Rider Earning', value: TransactionTypeEnum.RiderEarning },
        { name: 'Refund', value: TransactionTypeEnum.Refund },
        { name: 'Top Up Wallet', value: TransactionTypeEnum.TopUpWallet },
        { name: 'PayOut', value: TransactionTypeEnum.PayOut },
        { name: 'Rider Commission', value: TransactionTypeEnum.RiderCommission },
        { name: 'Daily Service Fee', value: TransactionTypeEnum.DailyServiceFee },
        { name: 'PayOut Pending', value: TransactionTypeEnum.PayOutPending },
        { name: 'PayOut Fee', value: TransactionTypeEnum.PayOutFee },
        { name: 'PayOut Restore', value: TransactionTypeEnum.PayOutRestore },
        { name: 'Cancellation Fee', value: TransactionTypeEnum.CancellationFee },
        { name: 'Waiting Fee', value: TransactionTypeEnum.WaitingFee },
        { name: 'PayOut Fee Restore', value: TransactionTypeEnum.PayOutFeeRestore },
        { name: 'Waiting Fee Rider Earning', value: TransactionTypeEnum.WaitingFeeRiderEarning },
        { name: 'Cancellation Fee Rider Earning', value: TransactionTypeEnum.CancellationFeeRiderEarning },
        { name: 'Withholding Tax', value: TransactionTypeEnum.WithholdingTax },
        { name: 'Referral Earning', value: TransactionTypeEnum.ReferralEarning },
        { name: 'Prize Money', value: TransactionTypeEnum.PrizeMoney },
        { name: 'Rider Service Fee', value: TransactionTypeEnum.RiderServiceFee },
        { name: 'Cash Rider Earning', value: TransactionTypeEnum.CashRiderEarning },
        { name: 'Rider Tip', value: TransactionTypeEnum.RiderTip },
        { name: 'Xpress Incentive', value: TransactionTypeEnum.XpressIncentive },
        { name: 'Rider Transfer To Cash Wallet', value: TransactionTypeEnum.RiderTransferToCashWallet },
        { name: 'PayOut To Payment Card', value: TransactionTypeEnum.PayOutToPaymentCard },
        { name: 'TopUp From Payment Card', value: TransactionTypeEnum.TopUpFromPaymentCard },
        { name: 'Adjust Wallet Balance', value: TransactionTypeEnum.AdjustWalletBalance },
        { name: 'Void', value: TransactionTypeEnum.Void },
        { name: 'Online Time Incentive', value: TransactionTypeEnum.OnlineTimeIncentive },
        { name: 'Rxp Daily Deduction', value: TransactionTypeEnum.RxpDailyDeduction },
        { name: 'Rxp Guarantee Pay', value: TransactionTypeEnum.RxpGuaranteePay },
        { name: 'Admin Adjustment - 9.9 15K Top Up', value: TransactionTypeEnum.AdminAdjustmentNineNine15KTopUp },
        { name: 'Admin Adjustment - 4K Top Up', value: TransactionTypeEnum.AdminAdjustment4KTopUp },
        { name: 'Admin Adjustment - General Adjustment', value: TransactionTypeEnum.GeneralAdjustment },
    ];
}
